import React, { Component } from 'react';
import Calendar from 'lib/Calendar';
import classNames from 'classnames';

export default class DayPicker extends Component {
  render() {
    // startDate and endDate can be ommitted if matrix is supplied via props
    const { startDate, endDate, selectedDate, onSelect } = this.props;
    const formattedSelectedDate = selectedDate ? selectedDate.format('YYYY-MM-DD') : '';
    const daysWithEvents = this.props.daysWithEvents || {};

    const matrix = this.props.matrix || Calendar.getMatrix(startDate, endDate);

    // If a single week
    if (matrix.length === 1) {
      return (
        <div className="full-screen-mini full-screen-calendar">
          <table>
            <thead>
              <tr>
                <th><div className="text-uppercase weekday-label">sun</div></th>
                <th><div className="text-uppercase weekday-label">mon</div></th>
                <th><div className="text-uppercase weekday-label">tue</div></th>
                <th><div className="text-uppercase weekday-label">wed</div></th>
                <th><div className="text-uppercase weekday-label">thu</div></th>
                <th><div className="text-uppercase weekday-label">fri</div></th>
                <th><div className="text-uppercase weekday-label">sat</div></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {matrix[0].map((day, j) => {
                  const hasEvents = {}.hasOwnProperty.call(daysWithEvents, day.date);
                  return (
                    <td key={`week${j}${day.date}`}>
                      <div
                        className={classNames({
                          'date-of-week': true,
                          clickable: true,
                          today: day.isToday,
                          'has-events': hasEvents,
                          'is-selected': (formattedSelectedDate === day.date),
                        })}
                        onClick={() => onSelect(day.moment)}
                      >
                        {day.moment.get('date')}
                      </div>
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    const currentMonth = this.props.month;

    return (
      <div className="full-screen-calendar full-screen-mini">
        <table>
          <thead>
            <tr>
              <th><div className="text-uppercase weekday-label">sun</div></th>
              <th><div className="text-uppercase weekday-label">mon</div></th>
              <th><div className="text-uppercase weekday-label">tue</div></th>
              <th><div className="text-uppercase weekday-label">wed</div></th>
              <th><div className="text-uppercase weekday-label">thu</div></th>
              <th><div className="text-uppercase weekday-label">fri</div></th>
              <th><div className="text-uppercase weekday-label">sat</div></th>
            </tr>
          </thead>
          <tbody>
            {matrix.map((week, i) => (
              <tr key={`month_i${i}${currentMonth}`}>
                {week.map((day, j) => {
                  const hasEvents = {}.hasOwnProperty.call(daysWithEvents, day.date);
                  return (
                    <td key={`month${j}${day.date}`}>
                      <div
                        className={classNames({
                          'date-of-week': true,
                          clickable: true,
                          today: day.isToday,
                          'has-events': hasEvents,
                          'not-this-month': (day.moment.format('M') !== currentMonth),
                          'is-selected': (formattedSelectedDate === day.date),
                        })}
                        onClick={() => onSelect(day.moment)}
                      >
                        {day.moment.get('date')}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/calendar/DayPicker.js